export const findCategoryBySlug = ({ categories, slugList }: { categories: any[], slugList: any[] }) => {
    let current = categories; // Start with top-level categories
    let match = null;

    for (const slug of slugList) {
        match = current?.find((cat) => cat?.slug === slug);
        if (match) {
            current = match.children; // Move to the next level (children)
        } else {
            return null; // Return null if no match is found
        }
    }

    return match; // Return the final matched category
};


export const generateCategoryBreadcrumbSchema = (pathSegments: string[], baseUrl: string) => {
    const breadcrumbItems = pathSegments.map((segment, index) => ({
        "@type": "ListItem",
        "position": index + 1,
        "name": segment.replace(/-/g, ' ').replace(/\b\w/g, char => char.toUpperCase()), // Capitalize each word
        "item": `${baseUrl}/${pathSegments.slice(0, index + 1).join("/")}`,
    }));

    return {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        "itemListElement": breadcrumbItems,
    };
};